import React from 'react';
import { useTranslate } from 'features/languages';
import { Button } from 'lib/@mui';
import { Add } from 'lib/@mui/Icons';

import { EZLOGIC_BUTTON_CREATE_NEW_CONTAINER } from 'constants/language_tokens';
import { useNavigate } from 'react-router-dom';

export const CreateContainerButton = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();
    const navigaToCreateVirtualDeviceForm = () => {
        navigate('/ezlo/virtual-device/create');
    };

    return (
        <Button color="primary" variant="outlined" onClick={navigaToCreateVirtualDeviceForm}>
            <Add />
            {t(EZLOGIC_BUTTON_CREATE_NEW_CONTAINER)}
        </Button>
    );
};
